import { render } from "./create_paralympic_equipment.vue?vue&type=template&id=0045be55&scoped=true"
import script from "./create_paralympic_equipment.vue?vue&type=script&lang=js"
export * from "./create_paralympic_equipment.vue?vue&type=script&lang=js"

import "./create_paralympic_equipment.vue?vue&type=style&index=0&id=0045be55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0045be55"]])

export default __exports__